import { NgModule } from '@angular/core';
import { ReplacePipe } from './replace/replace.pipe';
import { SortPipe } from './sort/sort.pipe';
import { VersionToNumber } from './versionToNumber/versionToNumber.pipe';
import { TimeConverterPipe } from './time-converter/time-converter.pipe';
import { SortByDatePipe } from './sortByDate/sortByDate.pipe';
import { CurrencyCustomPipe } from './currencyCustom/currency-custom.pipe';

@NgModule({
  declarations: [
    ReplacePipe,
    SortPipe,
    SortByDatePipe,
    VersionToNumber,
    TimeConverterPipe,
    CurrencyCustomPipe,
  ],
  exports: [
    ReplacePipe,
    SortPipe,
    SortByDatePipe,
    VersionToNumber,
    TimeConverterPipe,
    CurrencyCustomPipe
  ]
})
export class PipesModule {

}
